export default __webpack_public_path__ + "static/media/logo-cutilei-white.dd6cd605.png";